export default function trackGA() {
    const { origin, pathname, hash } = window.location;
    if (window.gtag) {
        window.gtag('config', window.GA_TRACKING_ID, {
            // eslint-disable-line
            page_location: origin,
            page_path: `${pathname}${hash}`,
        });
    }
    if (window._paq) {
        window._paq.push(['setCustomUrl', window.location]);
        window._paq.push(['trackPageView']);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/app/actions/trackPageView.js